import authApi from './authApi'
import accountApi from './accountApi'

export default { 
    ...authApi,
    ...accountApi
}

